import axios from "axios";

import apiRoutes from "../../constants/api-routes";

export const validatePluginId = (id) => {
	if (isNaN(id)) {
		return false;
	}
	
	return Number(id) > 0 && Number.isInteger(Number(id));
};

export const createPluginExistenceChecker = (authHeader) => {
	return async (id) => {
		try {
			const response = await axios.get(apiRoutes.getPlugin(id), { headers: authHeader });
			return !!response.data && !response.data.error;
		} catch (error) {
			console.error("Plugin not found:", error);
			return false;
		}
	};
};

const pluginValidation = {
	validatePluginId,
	createPluginExistenceChecker
};

export default pluginValidation;